import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  // {
  //   path: '',
  //   loadChildren: () => import('./modules/virtual-office/virtual-office.module').then(m => m.VirtualOfficeModule)
  // },
  {
    path: 'ofivirtual',
    loadChildren: () => import('./modules/virtual-office/virtual-office.module').then(m => m.VirtualOfficeModule)
  },
  {
    path: 'usuario',
    loadChildren: () => import('./modules/user-management/user-management.module').then(m => m.UserManagementModule)
  },
  {
    path: 'stdln',
    loadChildren: () => import('./modules/standalone/standalone.module').then(m => m.StandaloneModule)
  },
  {
    path: 'withoutlogin',
    loadChildren: () => import('./modules/without-login/without-login.module').then(m => m.WithoutLoginModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
